import ContactMe from "../main/components/ContactMe";
import ListServices from "./components/services";

function MainPage() {
  return (
    <>
        <div className="text-center text-white my-5">
            <h1 className="text-5xl black-ops-font">Services I offer!</h1>
            <ListServices />
        </div>
        <p className="text-center text-white">Anything else I can help you with? Reach out to me below!</p>
        <ContactMe />
    </>
  );
}

export default MainPage;
